var BraintreeClient = (function (braintree, $, api) {

    var BraintreeClient = function () {
        this._ready = new $.Deferred();
        this.instance = null;
    };

    function IsAuthorized() {
        if (window.isAuthorized == null) {
            if (!app.settings.get('UseGuestCheckout')) {
                window.isAuthorized = true;
            } else {
                window.isAuthorized = !(app.cookie.get('us') === null || app.cookie.get('us') === 'unl');
            }
        }
        return window.isAuthorized;
    }

    $.extend(BraintreeClient.prototype, {
        init: function (token) {            
            braintree.client.create({
                authorization: token
            }, $.proxy(this._callback, this));
        },
        _callback: function (createErr, instance) {
            if (createErr) {
                this._ready.reject(createErr);
            } else{
                this.instance = instance;
                this._ready.resolve(instance);
            }
        }
    });

    return {
        init: function () {

            var isPublic = !IsAuthorized();

            /*Do not initialize Braintee for undefined customers*/
            if (!isPublic && (app.cookie.get('us') === null || app.cookie.get('us') === 'unl')) {
                return new $.Deferred().promise();
            }

            if (!window._btClient) {
                window._btClient = new BraintreeClient();
                var method = $.proxy((isPublic && api.getPublicPaymentToken || api.getPaymentToken), api);

                method({ hideErrors: true }).done(function(data) {
                    window._btClient.init(data.Value.Token);
                });
            }

            return window._btClient._ready.promise();
        },
        ready: function (cb) {
            _ready.done(cb);
        }
    };
})(window.braintree, jQuery, api);